import { z } from 'zod/v3';

export const OpenEditSessionResponseSchema = z.object({
  id: z.string(),
});

export const InsertDraftsResponseSchema = z.object({
  insertedIds: z.array(z.number()),
});

export const HasPendingDraftsSchema = z.object({
  hasAnyPendingDrafts: z.boolean(),
});

export type OpenEditSessionResponseType = z.infer<
  typeof OpenEditSessionResponseSchema
>;
export type InsertDraftsResponseType = z.infer<
  typeof InsertDraftsResponseSchema
>;
export type HasPendingDraftsType = z.infer<typeof HasPendingDraftsSchema>;
